import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import { PreWithCopy } from "../../Monitor/components/LogViews";
import { EVENT_TYPE_META, formatDateTime, formatDuration, statusPillClass } from "../utils";

const TraceEventRow = ({ event, sequence, maxMs, expanded, onToggle }) => {
  const meta = EVENT_TYPE_META[event?.event_type] || { icon: "circle", pillClass: "default", label: event?.event_type };
  const pillClass = statusPillClass(event?.status);
  const pct = Math.max(2, Math.round(((event?.duration_ms || 0) / Math.max(1, maxMs)) * 100));

  return (
    <div className="timeline_row">
      <span className={`timeline_dot ${pillClass}`} />
      <div className="timeline_row_header" onClick={onToggle}>
        <span className="timeline_seq">{sequence}</span>
        <MaterialIcon name={meta.icon} />
        <span className={`status_pill ${meta.pillClass}`}>{meta.label}</span>
        <span className="timeline_label">{event?.stage_label || event?.event_type}</span>
        <span className={`status_pill ${pillClass}`}>{event?.status || "—"}</span>
        <div className="duration_cell">
          <div className="duration_bar">
            <div className={`duration_bar_fill ${pillClass}`} style={{ width: `${pct}%` }} />
          </div>
          <span className="duration_label">{formatDuration(event?.duration_ms)}</span>
        </div>
        <MaterialIcon name={expanded ? "expand_less" : "expand_more"} />
      </div>
      {!expanded && event?.message && <div className="timeline_message">{event.message}</div>}
      {expanded && (
        <div className="timeline_expanded_body">
          {event?.message && <div className="font_size_xsmall mb_1">{event.message}</div>}
          <PreWithCopy label="Payload" value={event?.payload} />
          <div className="timeline_meta_line">
            {event?.source} · {event?.source_row_id} · {formatDateTime(event?.started_at)}
            {event?.completed_at ? ` → ${formatDateTime(event.completed_at)}` : ""}
          </div>
        </div>
      )}
    </div>
  );
};

export default TraceEventRow;
